import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import QualificationsForm from "../../components/Qualifications/QualificationsForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const QualificationsEdit = ({classes, qualification, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('qualifications.edit_machine')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('schedules.back'),
                    href: redirectAfterSubmit,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(redirectAfterSubmit);
                    },
                }
            ]}
        />

        <Card>
            <CardContent>
                <QualificationsForm
                    values={qualification}
                    formUrl={formUrl}
                    isEdit={true}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default QualificationsEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/machines/Edit.jsx